import { NotifyData } from 'domain/entities/NotifyEntity';

interface props {
    data: NotifyData;
}

const IMPORTANCE_LEVEL = 'IMPORTANT';

export const NotifyLevelComponent = ({ data }: props) => {
    const isImportant = data?.noticeMsgImportance?.toUpperCase() == IMPORTANCE_LEVEL;

    return (
        <div className="flex items-center gap-1">
            <div className={`message-level ${isImportant ? 'type-important' : 'type-normal'}`}>
                <div className="text-wrapper">{data.noticeMsgImportanceName}</div>
            </div>
        </div>
    );
};
